import React from 'react'
import { PickyEatersRoot, PickyEatersContainer, ButtonWrapper } from './PickyEaters.styles'
import { CopyColumnHeader } from '../../RawBenefits.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import eagerDog from '../../../../../public/assets/raw-benefits/dog-eagerly-waiting-for-raw.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Link from 'next/link'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'

export const PickyEaters: React.FC = () => {
  const { t } = useTranslation()

  const PickyEatersCopy = () => (
    <Stack gap="3" direction="column">
      <CopyColumnHeader>{t('raw-benefits:picky-eaters.title')}</CopyColumnHeader>
      <Text>
        <Trans
          i18nKey="raw-benefits:picky-eaters.body.0"
          components={{ Link: <Link href="blog/dog-food-for-picky-eaters" /> }}
        />
      </Text>
      <Text>{t('raw-benefits:picky-eaters.body.1')}</Text>
    </Stack>
  )

  return (
    <PickyEatersRoot>
      <PickyEatersContainer>
        <ImageWithText
          copyColumn={<PickyEatersCopy />}
          imageSrc={eagerDog}
          imageAlt="raw-benefits:picky-eaters.image-alt"
          imageSide="left"
          isMobileImageBottom
        />
        <ButtonWrapper>
          <Link href="/meal-plan" passHref>
            <Button as="a" className="cta">
              {t('raw-benefits:hero.primary-cta')}
            </Button>
          </Link>
        </ButtonWrapper>
      </PickyEatersContainer>
    </PickyEatersRoot>
  )
}

PickyEaters.displayName = 'PickyEaters'
